import { defineMessages, type MessageDescriptor } from 'react-intl';

export const i18n: Record<
	'folder' | 'folderIcon' | 'placeholder' | 'selected' | 'suggested',
	MessageDescriptor
> = defineMessages({
	folder: {
		id: 'search-page.search-page-relay.filters.product-filters.folder.folder',
		defaultMessage: 'Folder',
		description: 'Label for filtering Loom search results by folder.',
	},
	folderIcon: {
		id: 'search-page.search-page-relay.filters.product-filters.folder.folder-icon',
		defaultMessage: 'Folder',
		description: 'Accessible label for the Loom folder filter icon.',
	},
	placeholder: {
		id: 'search-page.search-page-relay.filters.product-filters.folder.placeholder',
		defaultMessage: 'Find folders',
		description: 'Placeholder for the Loom folder filter search input.',
	},
	selected: {
		id: 'search-page.search-page-relay.filters.product-filters.folder.selected',
		defaultMessage: 'Selected',
		description: 'Group heading for selected Loom folders.',
	},
	suggested: {
		id: 'search-page.search-page-relay.filters.product-filters.folder.suggested',
		defaultMessage: 'Suggested',
		description: 'Group heading for suggested Loom folders.',
	},
});
